import { render, staticRenderFns } from "./MySpaceRanking.vue?vue&type=template&id=1a534a21&scoped=true&"
import script from "./MySpaceRanking.vue?vue&type=script&lang=js&"
export * from "./MySpaceRanking.vue?vue&type=script&lang=js&"
import style0 from "./MySpaceRanking.vue?vue&type=style&index=0&id=1a534a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a534a21",
  null
  
)

export default component.exports